import { render, staticRenderFns } from "./FTPServiceAccount.vue?vue&type=template&id=31f4ae22"
import script from "./FTPServiceAccount.vue?vue&type=script&lang=js"
export * from "./FTPServiceAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports